import { Download } from "lucide-react";
import { downloadCsv } from "@/lib/csv";

// rows: array of arrays, first row = header. `filename` without extension.
export default function ExportButton({ filename, rows, disabled }) {
  const empty = !rows || rows.length <= 1;
  return (
    <button
      type="button"
      onClick={() => downloadCsv(`${filename}.csv`, rows)}
      disabled={disabled || empty}
      title="CSV로 내보내기"
      className="inline-flex items-center gap-1 rounded-lg bg-ink-50 px-2.5 py-2 text-xs font-medium text-ink-600 hover:bg-ink-100 disabled:opacity-40"
    >
      <Download className="h-3.5 w-3.5" />
      CSV
    </button>
  );
}
